// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"229":"056bcd43","787":"2cc4d09c"}[chunkId] + ".chunk.js";
};